/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 27/7/2023
 */
import BaseObject from "@shared/BaseObject.js";
import SimpleRecurrenceItem from "@shared/Recurrence/SimpleRecurrenceItem";
import TimeOption from "@shared/CoachingPackage/TimeOption";
import {Type} from "@qwoach/class-transformer-wrapper";

export default class GroupCoachingSettings extends BaseObject {

	groupTitle: string = null

	participantsLimit: number = null

	@Type(() => SimpleRecurrenceItem)
	recurrenceItem: SimpleRecurrenceItem = null

	startDate: number = null

	@Type(() => TimeOption)
	timeSlots: TimeOption[] = null

	numberOfSessions: number[] = []


	constructor(options = {}) {
		super();
		this.participantsLimit = options.participantsLimit || null
		this.recurrenceItem = options.recurrenceItem || null
		this.startDate = options.startDate || null
		this.timeSlots = options.timeSlots || null
		this.groupTitle = options.groupTitle || null
		this.sessionTypeId = options.sessionTypeId || null
		this.sessionTypeTitle = options.sessionTypeTitle || null
		this.sessionDuration = options.sessionDuration || null
		this.numberOfSessions = options.numberOfSessions || []
	}
}
